module.exports = __webpack_public_path__ + "img/ZB53详情页_13.4312b53e.jpg";